import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

// Register necessary chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const PayoutBarChart = ({
  dataPoints = [100, 80, 50, 130, 60],
  labels = ["Apr 11", "Apr 12", "Apr 13", "Apr 14", "Apr 15"],
  theme = "dark", // default to dark for similar look
}) => {
  const chartData = {
    labels,
    datasets: [
      {
        label: "Payout",
        data: dataPoints,
        backgroundColor: "#e9965c",
        borderRadius: 2,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) =>
            `$${context.parsed.y.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: theme === "dark" ? "#fff" : "#23293A",
          font: { size: 14 },
        },
      },
      y: {
        grid: {
          color: theme === "dark" ? "#2C3447" : "#e0e0e0",
          drawBorder: false,
        },
        ticks: {
          color: theme === "dark" ? "#fff" : "#23293A",
          font: { size: 14 },
          callback: (value) =>
            `$${Number(value).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
        },
      },
    },
  };

  return (
    <div style={{ width: 320, height: 200 }}>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default PayoutBarChart;